import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { TabsContext } from './TabsContext';
import Tab from './Tab';
import IconTab from './IconTab';

export { Tab, IconTab };

const VARIANT_CLASSES = {
    default: 'gap-1.5 bg-dark-blue/5',
    // Same look as the type filter of the Tagging page
    solid: 'gap-1 bg-white border border-gray-200 shadow-sm',
};

export default function Tabs(props) {
    const { value, onChange, children, className, disabledTransition = false, variant = 'default' } = props;

    return (
        <TabsContext.Provider value={{ activeTab: value, setActiveTab: onChange, disabledTransition, variant }}>
            <div
                role="tablist"
                aria-label="Tabs"
                className={cn(
                    'flex items-center p-1 rounded-md h-11 overflow-x-auto scrollbar-none',
                    VARIANT_CLASSES[variant],
                    className,
                )}
            >
                {children}
            </div>
        </TabsContext.Provider>
    );
}

Tabs.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    disabledTransition: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'solid']),
};
